/* ============================================================================
   SUNNY STRIPES — QUOTE-TO-CART VARIANT MAP                    GENERATED FILE
   ----------------------------------------------------------------------------
   DO NOT EDIT BY HAND. Produced by emit-variants.js from the live catalog.
   Re-emit after any catalog sync - see the note in ss-rates.js.

   WHAT IT IS FOR
   The quote builders price a lawn from ss-rates.js. The products in the store
   carry Shopify's own copy of those same prices, keyed by SKU. This file is the
   only place the two are joined, so a "Book now" button can put exactly what
   was quoted into the cart without any tool hard-coding a variant ID.

   HOW A TOOL USES IT

     var sku = SS_VARIANTS.skuFor("aerseed", "m");        // "SS-AERSEED-M"
     var url = SS_VARIANTS.cartUrl([{ sku: sku, qty: 1 }]);
     if (url) location.href = url;                        // straight to the cart

   cartUrl() takes any number of line items and returns ONE url, so a customer
   who ticked aeration, overseeding and a fall cleanup lands in a cart holding
   all three. It returns null if any SKU is unknown - callers must check, and
   fall back to the lead form rather than sending someone to a broken cart.

   WHAT IS DELIBERATELY NOT HERE
   Snow, mulch, rock and hydroseeding have no products (snow is quoted per
   push; the others are quote-only because the material is the price), and the
   commercial maintenance program is priced on measured area rather than size
   tiers, so none of them can be expressed as a variant. skuFor() returns null
   for those, which is the honest answer, and the tools show a lead form.
   ============================================================================ */
(function () {
  "use strict";

  var MAP = {
    "SS-AERATE-A1": 46221749911786,
    "SS-AERATE-A3": 46221749944554,
    "SS-AERATE-L": 46221749846250,
    "SS-AERATE-M": 46221749813482,
    "SS-AERATE-S": 46221749780714,
    "SS-AERATE-XL": 46221749879018,
    "SS-AERSEED-A1": 46221749715178,
    "SS-AERSEED-A3": 46221749747946,
    "SS-AERSEED-L": 46221749649642,
    "SS-AERSEED-M": 46221749616874,
    "SS-AERSEED-S": 46221749584106,
    "SS-AERSEED-XL": 46221749682410,
    "SS-CLEANUPFALL-A1": 46221751288042,
    "SS-CLEANUPFALL-A3": 46221751320810,
    "SS-CLEANUPFALL-L": 46221751222506,
    "SS-CLEANUPFALL-M": 46221751189738,
    "SS-CLEANUPFALL-S": 46221751156970,
    "SS-CLEANUPFALL-XL": 46221751255274,
    "SS-CLEANUPSPRING-A1": 46221751091434,
    "SS-CLEANUPSPRING-A3": 46221751124202,
    "SS-CLEANUPSPRING-L": 46221751025898,
    "SS-CLEANUPSPRING-M": 46221750993130,
    "SS-CLEANUPSPRING-S": 46221750960362,
    "SS-CLEANUPSPRING-XL": 46221751058666,
    "SS-DETHATCH-A1": 46221750305002,
    "SS-DETHATCH-A3": 46221750337770,
    "SS-DETHATCH-L": 46221750239466,
    "SS-DETHATCH-M": 46221750206698,
    "SS-DETHATCH-S": 46221750173930,
    "SS-DETHATCH-XL": 46221750272234,
    "SS-FERT-A1": 46221750698218,
    "SS-FERT-A3": 46221750730986,
    "SS-FERT-L": 46221750632682,
    "SS-FERT-M": 46221750599914,
    "SS-FERT-S": 46221750567146,
    "SS-FERT-XL": 46221750665450,
    "SS-GRUB-A1": 46221750894826,
    "SS-GRUB-A3": 46221750927594,
    "SS-GRUB-L": 46221750829290,
    "SS-GRUB-M": 46221750796522,
    "SS-GRUB-S": 46221750763754,
    "SS-GRUB-XL": 46221750862058,
    "SS-IRRIGATION-A1": 46295635198186,
    "SS-IRRIGATION-L": 46295635132650,
    "SS-IRRIGATION-M": 46295635099882,
    "SS-IRRIGATION-S": 46295635067114,
    "SS-IRRIGATION-XL": 46295635165418,
    "SS-MOW-SEASON-A1-BW": 46221751976170,
    "SS-MOW-SEASON-A1-W": 46221751943402,
    "SS-MOW-SEASON-A3-BW": 46221752041706,
    "SS-MOW-SEASON-A3-W": 46221752008938,
    "SS-MOW-SEASON-L-BW": 46221751845098,
    "SS-MOW-SEASON-L-W": 46221751812330,
    "SS-MOW-SEASON-M-BW": 46221751779562,
    "SS-MOW-SEASON-M-W": 46221751746794,
    "SS-MOW-SEASON-S-BW": 46221751714026,
    "SS-MOW-SEASON-S-W": 46221751681258,
    "SS-MOW-SEASON-XL-BW": 46221751910634,
    "SS-MOW-SEASON-XL-W": 46221751877866,
    "SS-MOW-VISIT-A1": 46221751615722,
    "SS-MOW-VISIT-A3": 46221751648490,
    "SS-MOW-VISIT-L": 46221751550186,
    "SS-MOW-VISIT-M": 46221751517418,
    "SS-MOW-VISIT-S": 46221751484650,
    "SS-MOW-VISIT-XL": 46221751582954,
    "SS-OVERSEED-A1": 46221750108394,
    "SS-OVERSEED-A3": 46221750141162,
    "SS-OVERSEED-L": 46221750042858,
    "SS-OVERSEED-M": 46221750010090,
    "SS-OVERSEED-S": 46221749977322,
    "SS-OVERSEED-XL": 46221750075626,
    "SS-SHRUB-L": 46221751386346,
    "SS-SHRUB-S": 46221751353578,
    "SS-SHRUB-XL": 46221751419114,
    "SS-TOPAER-A1": 46226108874986,
    "SS-TOPAER-A3": 46226108907754,
    "SS-TOPAER-L": 46226108809450,
    "SS-TOPAER-M": 46226108776682,
    "SS-TOPAER-S": 46226108743914,
    "SS-TOPAER-XL": 46226108842218,
    "SS-TOPDRESS-A1": 46221750501610,
    "SS-TOPDRESS-A3": 46221750534378,
    "SS-TOPDRESS-L": 46221750436074,
    "SS-TOPDRESS-M": 46221750403306,
    "SS-TOPDRESS-S": 46221750370538,
    "SS-TOPDRESS-XL": 46221750468842,
    "SS-TOUCHUP-A1": 46226557337834,
    "SS-TOUCHUP-A3": 46226557370602,
    "SS-TOUCHUP-L": 46226557272298,
    "SS-TOUCHUP-M": 46226557239530,
    "SS-TOUCHUP-S": 46226557206762,
    "SS-TOUCHUP-XL": 46226557305066
  };

  /* Tier keys are lowercase in the rate card ("m", "a1") and uppercase in the
     SKU. Nothing else about a tier is encoded, so a new size band added to
     TIERS only needs the catalog rebuilt - no tool changes. */
  function tier(t) { return String(t || "").toUpperCase(); }

  /* Services whose product is a straight size-tier grid. */
  var SIZED = {
    aerseed: "AERSEED", aerate: "AERATE", overseed: "OVERSEED", dethatch: "DETHATCH",
    topdress: "TOPDRESS", fert: "FERT", grub: "GRUB", touchup: "TOUCHUP",
    cleanupSpring: "CLEANUPSPRING", cleanupFall: "CLEANUPFALL",
    /* Temporary irrigation, added 2026-09-16. Five bands only - above an acre
       it is quoted on site, so there is deliberately no SS-IRRIGATION-A3 and
       skuFor("irrigation","a3") names a SKU that has() reports as missing. */
    irrigation: "IRRIGATION",
    /* topdressing + core aeration, sold as one already-discounted line - see
       the bundle note in build-products.js. */
    topdressAeration: "TOPAER"
  };

  /* Shrub is the odd one. Its rate is dollars per 1,000 sq ft of LAWN, floored
     at $150 and capped at $450, so Small and Medium price identically and the
     top three do too. The catalog collapses six tiers into the three bands that
     actually differ; this maps a rate-card tier onto the right band. */
  function shrubBand(t) {
    t = tier(t);
    if (t === "S" || t === "M") return "S";
    if (t === "L") return "L";
    return "XL";
  }

  function skuFor(service, t, opts) {
    opts = opts || {};
    if (service === "shrub")   return "SS-SHRUB-" + shrubBand(t);
    if (service === "mow") {
      if (opts.season) {
        return "SS-MOW-SEASON-" + tier(t) + "-" + (opts.frequency === "biweekly" ? "BW" : "W");
      }
      return "SS-MOW-VISIT-" + tier(t);
    }
    var s = SIZED[service];
    return s ? "SS-" + s + "-" + tier(t) : null;
  }

  function id(sku) {
    return Object.prototype.hasOwnProperty.call(MAP, sku) ? MAP[sku] : null;
  }

  /* items: [{ sku, qty }] -> "/cart/<id>:<qty>,<id>:<qty>" | null
     Returns null on ANY unknown SKU. A partially correct cart is worse than no
     cart: the customer would check out having paid for some of what they were
     quoted and not the rest, and would reasonably expect all of it. */
  function cartUrl(items) {
    if (!items || !items.length) return null;
    var parts = [], i, v, q;
    for (i = 0; i < items.length; i++) {
      v = id(items[i].sku);
      if (!v) return null;
      q = Math.max(1, parseInt(items[i].qty, 10) || 1);
      parts.push(v + ":" + q);
    }
    return "/cart/" + parts.join(",");
  }

  window.SS_VARIANTS = {
    generated: "2026-09-16",
    count: 92,
    map: MAP,
    id: id,
    has: function (sku) { return id(sku) !== null; },
    skuFor: skuFor,
    cartUrl: cartUrl
  };
})();
